if(!customElements.get('customer-component')){
    customElements.define('customer-component', class CustomerComponent extends HTMLElement{
        constructor(){
            super()
            this.init()
        }
        init(){
            const accepts_input = this.querySelector('#accepts-input');
            const customer_btn = this.querySelector('#cu-home-customer-btn');
            accepts_input?.addEventListener('change', (e) => {
              e.target.checked ? (customer_btn.disabled = false) : (customer_btn.disabled = true);
            });
        
            const form = this.querySelector('#_customer-from_');
            const verify_field = this.querySelector('.home-customer-input-ward .verify-field');
            const regEmail =
              /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            customer_btn?.addEventListener(
              'click',
              () => {
                let emailInput = this.querySelector('.home-customer-input-ward .home-customer-input');
                // 检查必填字段是否已填写
                if (!emailInput.value) {
                  verify_field.innerText = 'Bitte füllen Sie das Feld aus';
                  verify_field.classList.add('is_visibility');
                  return;
                }
                if (!regEmail.test(emailInput.value)) {
                  verify_field.innerText = 'Bitte geben Sie die korrekte E-Mail Adresse ein';
                  verify_field.classList.add('is_visibility');
                  return;
                }
                form.submit();
              },
              false
            );
        
            let email_Input = this.querySelector('.home-customer-input-ward .home-customer-input');
            email_Input.onfocus = () => {
              verify_field.classList.remove('is_visibility');
            };
        }
    })
}